const regexMarkers = /%[\w\d\-_.]+%/gm;
const regexMarkersPercent = /%*/g;

export function getMakersInText(text, markers) {
  return (text.match(regexMarkers) || [])
    .map(i =>
      (markers || []).includes(i.replace(regexMarkersPercent, ""))
        ? i.replace(regexMarkersPercent, "")
        : null
    )
    .filter(i => !!i);
}
